module.exports = __webpack_public_path__ + "img/5.dff0757e.jpg";